import { head } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useMultiSelectState } from '../../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import { useIntegrationsState } from '../_load/IntegrationsLoader'
import MultiSelectMenu from '../../../../packages/kiti/components/multiSelect/MultiSelectMenu'
import { useIntegrationActionsList } from '../../../../utils/actions/integrations/list'

// TODO - create actions
const MultiRowsActions = () => {
  const { integrations, integrationsCount } = useIntegrationsState()
  const { selecteds, getSelectedData } = useMultiSelectState()

  const selectedIntegrations = getSelectedData(integrations)
  const menuOptions = useIntegrationActionsList(head(selectedIntegrations), selecteds)

  return <MultiSelectMenu options={menuOptions} />
}

export default MultiRowsActions
